import { Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'

import type { LinkProps } from '@tanstack/react-router'

type MenuLinkProps = LinkProps & {
	children: React.ReactNode
}

/**
 * Settings sidebar nav link (button-styled). Marks itself active only on an
 * exact path + search-param match (`exact`/`includeSearch`), so sibling
 * settings routes that share a prefix or query don't all light up at once.
 */
export const MenuLink = ({ children, to }: MenuLinkProps) => {
	return (
		<Button
			variant="link"
			nativeButton={false}
			className="flex items-center justify-start text-start"
			render={
				<Link
					to={to}
					className="text-muted-foreground data-[status=active]:text-foreground dark:text-muted-foreground data-[status=active]:dark:text-foreground data-[status=active]:font-semibold data-[status=active]:hover:no-underline"
					activeOptions={{ exact: true, includeSearch: true }}
				>
					{children}
				</Link>
			}
		/>
	)
}

/** Mobile (horizontal scroller) variant of MenuLink — same exact-match active rule. */
export const MobileMenuLink = ({ children, to }: MenuLinkProps) => {
	return (
		<Link
			to={to}
			className="text-muted-foreground hover:bg-muted hover:text-foreground data-[status=active]:bg-muted data-[status=active]:text-foreground shrink-0 rounded-md px-3 py-1.5 text-sm transition-colors"
			activeOptions={{ exact: true, includeSearch: true }}
		>
			{children}
		</Link>
	)
}
